import React, { useState } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useWebp } from "../../../../../hooks/common";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { getProductUrl, getColor } from "../../../../../../utils/product";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { action_fetch_promotions } from "../../../../../../store/actions/pages/product";
import { useDispatch } from "react-redux";


const ProductColorContainer = props => {
    useStyles(classes);
    const {products, selectedProduct, selectProduct, isBeautyMakeup} = props;
    const isWebp = useWebp()
    const dispatch = useDispatch()

    const isSameProduct = (p1, p2) => {
        return p1?.id === p2?.id && p1?.variants?.[0]?.color === p2?.variants?.[0]?.color;
    }

    const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp':''}`

    return (
        <React.Fragment>
            {
                products && <div className={classes.ColorProduct}>
                    {
                        products?.map((product, index) => isBeautyMakeup ? <a 
                            href={getProductUrl(product?.id, product?.name)} 
                            className={`${classes.GeneralColor} ${classes.BeautyColorItem} ${isSameProduct(product, selectedProduct) ? `${classes.Active}` : ""}`}
                            key={product?.id + index}
                            onClick={e => {
                                e.preventDefault()
                                // dispatch(action_fetch_promotions(product?.id))
                                selectProduct(product?.id, product?.variants?.[0]?.color)
                            }}
                        >
                            <span
                            className={classes.NormalColor}
                            style={{
                                backgroundColor: `${getColor(product?.variants?.[0]?.color)}`,
                                backgroundImage: product?.variants?.[0]?.colorImage ? `url(${product?.variants?.[0]?.colorImage})` : undefined
                            }}></span>

                            {
                                product?.hotColor && <span className={classes.HotColor}>
                                    <span>Hot</span>
                                </span>
                            }
                        </a> : <a 
                            key={product?.id + index} 
                            className={`${classes.GeneralColor} ${classes.ColorProductItem} ${isSameProduct(product, selectedProduct) ? `${classes.Active}` : ""}`} 
                            onClick={e => {
                                e.preventDefault()
                                // dispatch(action_fetch_promotions(product?.id))
                                selectProduct(product?.id, product?.variants?.[0]?.color)
                            }}
                            href={getProductUrl(product?.id, product?.name)}
                        >
                            <span 
                            className={classes.NormalColor}
                            style={{
                                backgroundColor: `${getColor(product?.variants?.[0]?.color)}`,
                                backgroundImage: `url(${imagePrefix}/small/${product?.variants?.[0]?.image || product.pcMainImage})`
                            }}></span>

                            {
                                product?.hotColor && <span className={classes.HotColor}>
                                    <span>Hot</span>
                                </span>
                            }
                        </a>)
                    }
                </div>
            }
        </React.Fragment>
    )
}

const ProductColor = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { productVO, selectProduct, selectedProduct, isBeautyMakeup } = productHooks;

    return <React.Fragment>
        {
            productVO?.products?.length > 1 && <>
                <div className={`${classes.PPickContainer}`}>
                    <div className={classes.Hd}>
                        <span><FormattedMessage id="color" defaultMessage="Color" />:&nbsp;</span>
                        <span>{selectedProduct?.theme || selectedProduct?.variants[0]?.color}</span>
                    </div>

                    <div className={classes.Bd}>
                        <ProductColorContainer products={productVO?.products} selectedProduct={selectedProduct} selectProduct={selectProduct} isBeautyMakeup={isBeautyMakeup} />
                    </div>
                </div>
            </>
        }
    </React.Fragment>
}

export default ProductColor;